import {FC} from "react";
import {useTranslation} from "react-i18next";
import {useAnalytics} from "@common-core/react-analytics";
import {SplitButton} from "@interstate/components/SplitButton";
import {useClientEntity} from "../../context";
import {useNavigation} from "../../../navigation";
import {BoltIcon, PlusIcon} from "@interstate/components/Icons";

export const ManageHierarchySplitButton: FC = () => {
  const {t} = useTranslation();
  const {entity} = useClientEntity();
  const {productEvent} = useAnalytics();
  const {navigateTo} = useNavigation();
  return (
    <SplitButton
      id={`manage-hierarchy-split-button-${entity.caId}`}
      data-testid={`manage-hierarchy-split-button-${entity.caId}`}
      buttonStyle={"primary"}
      options={[
        {
          disabled: false,
          divider: false,
          icon: <PlusIcon />,
          id: "002",
          label: t("create-entity.create-org-label"),
          onSelect: function Xs(event: any) {
            navigateTo(event, `/create-operational-entity/${entity.caId}`);
          },
          value: "Create"
        },
        {
          disabled: false,
          divider: false,
          icon: <BoltIcon />,
          id: "001",
          label: t("create-entity.manage-hierarchy-label"),
          onSelect: function Xs(event: any) {
            navigateTo(
              event,
              `/create-operational-hierarchy/${entity.caId}/simple`
            );
          },
          value: "Manage"
        }
      ]}
      onClick={(event: any) => {
        productEvent({
          name: "manage-hierarchy-split",
          properties: {
            location: "Client Overview Tab",
            value: `${entity.caId}`,
            result: `${entity.caId}`
          }
        });
      }}>
      {t("entity-detail.manage-entity-options-button-text")}
    </SplitButton>
  );
};
